import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['category', 'eventType']

  selectCategory(event) {
    const category = event.currentTarget.dataset.category
    this.submitForm({ category })
  }

  selectEventType(event) {
    const eventType = event.currentTarget.dataset.eventType
    this.submitForm({ type: eventType })
  }

  submitForm(params) {
    const url = new URL(window.location.href)
    Object.entries(params).forEach(([key, value]) => {
      if (value === 'all') {
        url.searchParams.delete(key)
      } else {
        url.searchParams.set(key, value)
      }
    })
    window.location.href = url.toString()
  }
}
